import { createInsertSchema, createSelectSchema } from "drizzle-zod";
import { z } from "zod";
import { bucketTypes } from "../drizzle/bucketTypes.js";
export const bucketTypeSchema = createSelectSchema(bucketTypes, {
    key: (schema) => schema.meta({
        description: "Unique key identifying the bucket type (also the primary key)",
        example: "fix_fix_none_none",
    }),
    // Use z.coerce.date() for date fields because JSON serialization converts Date objects to ISO strings
    createdAt: () => z.coerce.date().meta({
        description: "Bucket type creation timestamp",
        example: "2024-01-15T10:30:00.000Z",
    }),
    updatedAt: () => z.coerce.date().meta({
        description: "Bucket type last update timestamp",
        example: "2024-01-15T10:30:00.000Z",
    }),
    title: (schema) => schema.meta({
        description: "Bucket type title",
        example: "Sprint",
    }),
    description: (schema) => schema.meta({
        description: "Bucket type description",
        example: "A time-boxed iteration for development work",
    }),
    fulfillmentCriterion: (schema) => schema.meta({
        description: "Criterion for determining bucket fulfillment",
        example: "quantity",
    }),
    startTimeFlexible: (schema) => schema.meta({
        description: "Whether start time is flexible",
        example: true,
    }),
    endTimeFlexible: (schema) => schema.meta({
        description: "Whether end time is flexible",
        example: true,
    }),
    targetQuantity: (schema) => schema.meta({
        description: "Target quantity type",
        example: "fixed",
    }),
}).describe("Bucket type object");
// Base schema using callbacks - stays in sync with Drizzle column types
const baseCreateBucketTypeSchema = createInsertSchema(bucketTypes, {
    key: (schema) => schema.meta({
        description: "Unique key identifying the bucket type (also the primary key)",
        example: "fix_fix_none_none",
    }),
    title: (schema) => schema.min(1, "Bitte gib einen Titel an").meta({
        description: "Bucket type title",
        example: "Sprint",
    }),
    description: (schema) => schema
        .meta({
        description: "Bucket type description",
        example: "A time-boxed iteration for development work",
    })
        .nullable(),
    fulfillmentCriterion: (schema) => schema.meta({
        description: "Criterion for determining bucket fulfillment",
        example: "quantity",
    }),
    startTimeFlexible: (schema) => schema
        .meta({
        description: "Whether start time is flexible",
        example: true,
    })
        .nullable(),
    endTimeFlexible: (schema) => schema
        .meta({
        description: "Whether end time is flexible",
        example: true,
    })
        .nullable(),
    targetQuantity: (schema) => schema
        .meta({
        description: "Target quantity type",
        example: "fixed",
    })
        .nullable(),
});
// Fix drizzle-zod bug: callbacks for nullable fields lose .optional() wrapper
// We extend the base schema to add .optional() to nullable fields
export const createBucketTypeSchema = baseCreateBucketTypeSchema
    .extend({
    description: baseCreateBucketTypeSchema.shape.description.optional(),
    startTimeFlexible: baseCreateBucketTypeSchema.shape.startTimeFlexible.optional(),
    endTimeFlexible: baseCreateBucketTypeSchema.shape.endTimeFlexible.optional(),
    targetQuantity: baseCreateBucketTypeSchema.shape.targetQuantity.optional(),
})
    .describe("Create bucket type request body");
